<template>
    <form-accordion
        name="transaction-defaults"
        section="Transaction Defaults"
        :url="url"
        method="patch"
        :closed="closed"
    >
        <percent-split
            :settings="settings"
        />
    </form-accordion>
</template>

<script>
import PercentSplit from './percent-split.vue';

export default {
    components: {
        PercentSplit,
    },

    props: {
        closed: { default: true },
        url: {},
        broker: {},
        settings: {},
    },
}
</script>
